    document.querySelectorAll(".product-form__buy-buttons, .product-sticky-form").forEach(function(element) {
        element.style.display = "block";
    });

    document.querySelector(".profilfarve").checked = true;
    document.querySelector(".custom-radio").checked = true;

    let customImages = document.querySelectorAll('.custom-image');
    customImages.forEach((image, index) => {
      if (index !== 0) {
        image.style.display = 'none';
        image.classList.add('invisible');
      }
    });  
  
  document.querySelectorAll('.main-picker .custom-swatch-picker .custom-swatch-label').forEach(mainPicker => {
    commonExecution();
    const mainInput = mainPicker.querySelector('input');
    
    if (mainInput.checked) {
      const mainTitle = mainPicker.getAttribute('title');
      document.querySelectorAll('.custom-image').forEach(innerPicker => {
        if (innerPicker.getAttribute('title') === mainTitle) {
          innerPicker.style.display = 'block';
          innerPicker.classList.remove("invisible");
          innerPicker.classList.add("visible");
          
          innerPicker.querySelectorAll('.custom-swatch-label').forEach(label => {
            const checkedImg = label.querySelector('input:checked + img');
            if (checkedImg) {
              document.querySelector('.update-img img').srcset = checkedImg.src;
            }
          });
        }
      });
    }
    
    mainPicker.addEventListener('click', () => {
      commonExecution();
      const mainTitle = mainPicker.getAttribute('title');
      
      document.querySelectorAll('.custom-image').forEach(innerPicker => {
        const innerTitle = innerPicker.getAttribute('title');
        
        if (innerTitle === mainTitle) {
          document.querySelectorAll('.custom-image').forEach(img => {
            img.style.display = 'none';
            img.classList.remove("visible");
            img.classList.add("invisible");
          });
  
          innerPicker.style.display = 'block';
          innerPicker.classList.remove("invisible");
          innerPicker.classList.add("visible");
  
          document.querySelectorAll('.custom-image .custom-radio').forEach(radio => {
            radio.disabled = true;
          });
  
          innerPicker.querySelectorAll(".custom-radio").forEach(radio => {
            radio.disabled = false;
          });
          
          innerPicker.querySelectorAll('.custom-swatch-label').forEach(label => {
            commonExecution();
            const checkedImg = label.querySelector('input:checked + img');
            if (checkedImg) {
              document.querySelector('.update-img img').srcset = checkedImg.src;
            }
          });
        }
      });
    });
  });

  document.querySelectorAll('.custom-image .custom-swatch-label').forEach(mainLabel => {
    const mainInput = mainLabel.querySelector('input');
    mainInput.addEventListener('click', () => {
      commonExecution();
      const inputImg = mainLabel.querySelector('input + img');
      const imgUrl = inputImg ? inputImg.src : '';
      document.querySelector('.update-img img').srcset = imgUrl;
  
      const checkbox = document.querySelector(`.custom-elements:not(.hidden) .custom-image .custom-swatch-label input[value="${mainInput.value}"]`);
      if (checkbox) checkbox.checked = true;
    });
  });

  /* Onload call */
  commonExecution();

  const limitInput = function() {
    const value = parseInt(this.value, 10);
    const max = parseInt(this.max, 10);
    const min = parseInt(this.min, 10);

    if (value > max) {
      this.value = max;
    } else if (value < min) {
      this.value = min;
    }
  };

  document.getElementById("bredde").addEventListener("change", limitInput);
  document.getElementById("calchojde").addEventListener("change", limitInput);

  document.addEventListener("change", function(event) {
    if (event.target.classList.contains("calculate")) {
      commonExecution();
    }
  });

  function commonExecution() {

    var profilfarve = jQuery('.profilfarve:checked').attr("data-profilfarve");
    var tykkelse    = jQuery('.tykkelse').find(':selected').attr("data-tykkelse");
    var profilramme = jQuery('.profilramme').find(':selected').attr("data-profilramme");
    var belgning    = jQuery('.belgning').find(':selected').attr("data-belgning");
    var endekappe   = jQuery('.endekappe').find(':selected').attr("data-endekappe");
    var bredde      = jQuery('.bredde').val();     // width
    var calchojde   = jQuery('.calchojde').val();  // height
    var glasstype  = jQuery('.custom-image:not([style="display: none;"])').find(".custom-radio").first().is(":checked"); /* glasstype == Clearglas */ 
    var MainTitle = jQuery('.visible .custom-radio:checked').val();
    var bredde_and_calchojde = 0;
    // console.log(MainTitle);

      document.querySelector(".custom-image.visible .custom-swatch-label:last-child")?.classList.remove("lastElementhide");
       if (tykkelse == 0) { // 8 MM
        var ranges = {
              "Klar glas": { 500: 4495, 600: 4595, 700: 4695, 800: 4795, 900: 4895, 1000: 6195, 1100: 6495, 1200: 6795, 1300: 7095 },
              "Klar Jernfattig": { 500: 5395, 600: 5495, 700: 5595, 800: 5695, 900: 5795, 1000: 7095, 1100: 7395, 1200: 7695, 1300: 7995 },
              "Materet glas": { 500: 5895, 600: 5995, 700: 6095, 800: 6195, 900: 6295, 1000: 7595, 1100: 7895, 1200: 8195, 1300: 8495 },
              "Røgfarvet glas": { 500: 4495, 600: 4595, 700: 4695, 800: 4795, 900: 4895, 1000: 6195, 1100: 6495, 1200: 6795, 1300: 7095 },
              "Bronzefarvet glas": { 500: 4695, 600: 4795, 700: 4895, 800: 4995, 900: 5095, 1000: 6395, 1100: 6695, 1200: 6995, 1300: 7295 },
              "Riflet glas": { 500: 5895, 600: 5995, 700: 6095, 800: 6195, 900: 6295, 1000: 7595, 1100: 7895, 1200: 8195, 1300: 8495 }
            } 
       }else{ // 10 MM
          var ranges = {
              "Klar glas": { 500: 5495, 600: 5595, 700: 5695, 800: 5795, 900: 5895, 1000: 7195, 1100: 7495, 1200: 7795, 1300: 8095 },
              "Klar Jernfattig": { 500: 6395, 600: 6495, 700: 6595, 800: 6695, 900: 6795, 1000: 8095, 1100: 8395, 1200: 8695, 1300: 8995 },
              "Materet glas": { 500: 6895, 600: 6995, 700: 7095, 800: 7195, 900: 7295, 1000: 8595, 1100: 8895, 1200: 9195, 1300: 9495 },
              "Røgfarvet glas": { 500: 5495, 600: 5595, 700: 5695, 800: 5795, 900: 5895, 1000: 7195, 1100: 7495, 1200: 7795, 1300: 8095 },
              "Bronzefarvet glas": { 500: 6595, 600: 6695, 700: 6795, 800: 6895, 900: 6995, 1000: 8295, 1100: 8595, 1200: 8895, 1300: 9195 },
              "Riflet glas": { 500: 6895, 600: 6995, 700: 7095, 800: 7195, 900: 7295, 1000: 8595, 1100: 8895, 1200: 9195, 1300: 9495 }
          }
       } 
        if (MainTitle in ranges) {

          const rangeKeys = Object.keys(ranges[MainTitle]).map(Number); // Convert keys to numbers
          let matchedKey = null;

          for (const key of rangeKeys) {
              if (bredde >= key && bredde < key + 100) { // Match within 100 increments
                  matchedKey = key;
                  break;
              }
          }

          bredde_and_calchojde = matchedKey !== null ? ranges[MainTitle][matchedKey] : "N/A";

            if (calchojde < 400 || calchojde > 2300) {
                bredde_and_calchojde = "Out of range";
            }
            // console.log(`Calculated value: ${bredde_and_calchojde}`);
        } else {
            // console.error(`Unknown main title: ${MainTitle}`);
        }

     var total = (parseFloat(profilramme) + parseFloat(belgning) + parseFloat(endekappe) + parseFloat(bredde_and_calchojde) + parseFloat(profilfarve));

     document.getElementById("custom-priceTicker").textContent = total;
     document.querySelector(".product-sticky-form__price").textContent = total + ' kr';
     document.getElementById("custom-qty").value = total;
  }

  document.getElementById("AddToCart").removeAttribute("disabled");
